import React from 'react';
import CompanyProfile from './CompanyProfile';

export default function TestCompanyProfile() {
  const sampleOrganizationData = {
    organization: 'Test Company Inc.',
    description: 'A test company for demonstrating the company profile functionality.',
    location: 'Test City, Test Country',
    phone: '+1 (555) 123-4567',
    email: 'test@company.com',
    website: 'https://testcompany.com',
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-4 md:p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-6 md:mb-8">
          <h1 className="mb-2 text-2xl font-bold text-slate-900 md:text-3xl">
            Company Profile Test
          </h1>
          <p className="text-sm text-slate-600 md:text-base">
            This is a test page to demonstrate the company profile functionality including media
            upload, client management, and project tracking.
          </p>
        </div>

        <CompanyProfile organizationData={sampleOrganizationData} />
      </div>
    </div>
  );
}
